import React from "react";
import Modal from "react-bootstrap/Modal";
import "./ResetPasswordConfirmationModal.scss";

export default class ResetPasswordConfirmationModal extends React.Component {
  render() {
    return (
      <Modal
        className="reset-password-confirmation-modal"
        size="sm"
        centered
        show={this.props.showModal}
        onHide={this.props.handleClose}
      >
        <div className="reset-password-confirmation-modal-content">
          <div className="header">
            <h3 className="title">Reset Password</h3>
          </div>

          <div className="body">
            <p>Are you sure you want to reset password?</p>
          </div>

          <div className="footer">
            <button
              className="btn-tertiary cancel-button"
              onClick={this.props.handleClose}
            >
              No
            </button>
            <button
              className="btn-primary create-button"
              onClick={this.props.openResetPasswordModal}
            >
              Yes
            </button>
          </div>
        </div>
      </Modal>
    );
  }
}
